/**
 * Theme colors derived from the application's CSS design system
 * These colors match the CSS variables defined in the global styles
 */

export const themeColors = {
  // Background colors
  background: '#ffffff',
  backgroundAlt: '#fafafa',
  
  // Foreground/Text colors
  foreground: '#030213',
  foregroundMuted: '#717182',
  
  // Border colors
  border: 'rgba(0, 0, 0, 0.1)',
  borderStrong: '#717182',
  
  // Primary colors
  primary: '#030213',
  primaryForeground: '#ffffff',
  
  // Secondary colors
  secondary: '#ececf0',
  secondaryForeground: '#030213',
  
  // Muted colors
  muted: '#ececf0',
  mutedForeground: '#717182',
  
  // Accent colors
  accent: '#e9ebef',
  accentForeground: '#030213',
  
  // Destructive/Error colors
  destructive: '#d4183d',
  destructiveForeground: '#ffffff',
  
  // Input colors
  inputBackground: '#f3f3f5',
  
  // Status colors
  success: '#15803d',
  warning: '#b45309',
  error: '#d4183d',
  
  // Day stripe colors (for calendar/timeline)
  dayStripeEven: '#ffffff',
  dayStripeOdd: '#f0f4ff',
  
  // Selection/Focus colors
  selection: '#030213',
  selectionForeground: '#ffffff',
  
  // Font weights
  fontWeightNormal: 400,
  fontWeightMedium: 500,
} as const;

export type ThemeColors = typeof themeColors;
